import { injectable } from '@servicetitan/react-ioc';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export type Response<T> = Promise<AxiosResponse<T>>;

@injectable()
export class HttpClient {
    api = axios.create({
        withCredentials: true,
        baseURL: process.env.ST_CLIENT_APP_API_URL,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    });

    addResponseFulfilledInterceptor = (
        interceptor: (value: AxiosResponse) => AxiosResponse | Promise<AxiosResponse>
    ) => {
        this.api.interceptors.response.use(interceptor);
    };

    addResponseRejectedInterceptor = (interceptor: (error: any) => any) => {
        this.api.interceptors.response.use(undefined, interceptor);
    };

    get<T>(url: string, config?: AxiosRequestConfig): Response<T> {
        return this.api.get(url, config);
    }

    post<T, D>(url: string, data?: D, config?: AxiosRequestConfig): Response<T> {
        return this.api.post(url, data, config);
    }

    put<T, D>(url: string, data: D, config?: AxiosRequestConfig): Response<T> {
        return this.api.put(url, data, config);
    }

    patch<T, D>(url: string, data: D, config?: AxiosRequestConfig): Response<T> {
        return this.api.patch(url, data, config);
    }

    delete(url: string, id: string | number, config?: AxiosRequestConfig) {
        return this.api.delete(`${url}/${id}`, config);
    }
}
